<template>
  <svg
    viewBox="0 0 582 175"
    class="h-full w-auto"
    fill="none"
    ref="line"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="path"
      d="M581 0V81.9265C581 92.9722 572.046 101.927 561 101.927H21C9.95432 101.927 1 110.881 1 121.927V175"
      stroke="currentColor"
      stroke-width="1.5"
    />
  </svg>
</template>



<script lang="ts" setup>

const { y } = useWindowScroll()
const line = useTemplateRef('line')

watch(y, () => {
  line.value?.style.setProperty('--scroll-y', `${line.value?.getBoundingClientRect().top}`)
})
</script>


<!-- css only -->
<!-- <style scoped>

.path {
  view-timeline-name: --subjectReveal;
  animation-timeline: --subjectReveal;
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  animation-name:dash;

  animation-direction: alternate;
  animation-timing-function: ease-in-out;
  /* animation-timing-function: cubic-bezier(0, 0.82, 0.98, 0.22); */
  animation-duration: 1ms; /* Firefox requires this to apply the animation */
}

@keyframes dash {
  from {
    stroke-dashoffset: 1022;
  }
  to {
    stroke-dashoffset: 0;
  }
}
</style> -->

<style scoped>
.path {
  stroke-dasharray: 1000;
  stroke-dashoffset: var(--scroll-y);
}
</style>
